const BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api/twitter`
  : "http://localhost:5000/api/twitter";

async function get(path) {
  const res = await fetch(`${BASE}${path}`);
  if (!res.ok) throw new Error(`Twitter API ${path} → ${res.status}`);
  return res.json();
}

export const twitterApi = {
  overview:   ()    => get("/overview"),
  publication: (pub) => get(`/${pub}`),
  tweets:      (pub) => get(`/${pub}/tweets`),
};
